import React from "react";
import {FormInput, ImageUpload, ValidateForm} from "../components/common/formValidation";


export class ImageTool extends React.Component {
    
    render() {
        return (
            <div>
                <ValidateForm>
                    <FormInput name="image" title="Image ID"/>
                    <ImageUpload name="image"/>
                </ValidateForm>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/admin/imageTool.js